var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "r-panel",
    { attrs: { title: _vm.title } },
    [
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2",
          attrs: { width: "100%", elevation: "0", outlined: "" },
        },
        [
          _c("v-card-title", { staticClass: "pa-0 ma-0 ml-1 mb-2" }, [
            _vm._v("Config"),
          ]),
          _c(
            "v-row",
            { staticClass: "pb-2 ma-0 pa-2", attrs: { dense: "" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "5", sm: "5" } },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c("r-currency-kind-dropdown", {
                        attrs: {
                          model: _vm.value.currency,
                          label: "Track Currency",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.value, "currency", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.payable && _vm.model
                    ? _c(
                        "v-row",
                        { staticClass: "pt-2", attrs: { dense: "" } },
                        [
                          _c("r-product-dropdown", {
                            attrs: {
                              model: _vm.model.product,
                              groups: _vm.product_groups,
                              label: " Track Product",
                            },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "product", $event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "7", sm: "7" } },
                [
                  _c("v-checkbox", {
                    staticClass: "mx-4 mt-4",
                    attrs: { label: "Reset on Complete", "hide-details": "" },
                    model: {
                      value: _vm.value.resetOnComplete,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "resetOnComplete", $$v)
                      },
                      expression: "value.resetOnComplete",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        {
          staticClass: "ma-0 pa-2 mt-3",
          attrs: { width: "100%", elevation: "0", outlined: "" },
        },
        [
          _c(
            "v-row",
            { staticClass: "pt-2", attrs: { dense: "" } },
            [
              _c("r-reward-bunch-table", {
                attrs: {
                  model: _vm.value.reward,
                  points: true,
                  label: "Reward",
                },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "reward", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.reminder
        ? _c(
            "v-card",
            {
              staticClass: "ma-0 pa-2 mt-3",
              attrs: { width: "100%", elevation: "0", outlined: "" },
            },
            [
              _c("v-card-title", { staticClass: "pa-0 ma-0 ml-1 mb-2" }, [
                _vm._v("Reminder"),
              ]),
              _c(
                "v-row",
                { staticClass: "pb-2 ma-0 pa-2", attrs: { dense: "" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.reminderItems,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Reminder",
                      multiple: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selection",
                          fn: function ({ parent, item, index }) {
                            return [
                              index < 3
                                ? _c("v-chip", [
                                    _c("span", [_vm._v(_vm._s(item.name))]),
                                  ])
                                : _vm._e(),
                              index === 3
                                ? _c(
                                    "span",
                                    { staticClass: "grey--text text-caption" },
                                    [
                                      _vm._v(
                                        " (+" +
                                          _vm._s(
                                            parent.selectedItems.length - 3
                                          ) +
                                          " others) "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2972301031
                    ),
                    model: {
                      value: _vm.value.reminder,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "reminder", $$v)
                      },
                      expression: "value.reminder",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }